import Button from "./Button";
import Modal from "./Modal";
import { ButtonStyle, RecordStatus } from "../../js/enums";

function SetStatusModal({
  handleRecordStatusChange,
  recordStatusToShow,
  setShowConfirmStatusChangeModal,
  singleRecord = false,
  state,
}) {
  const isActivate =
    String(recordStatusToShow) === String(RecordStatus.Inactive);
  const getBodyText = () => {
    if (state && state.name && singleRecord) {
      return isActivate
        ? `Are you sure you want to activate the ${state.name} record?`
        : `Are you sure you want to deactivate the ${state.name} record?  You can reactivate it later, if you wish.`;
    } else {
      return isActivate
        ? "Are you sure you want to activate the selected record(s)?"
        : "Are you sure you want to deactivate the selected record(s)?  You can reactivate it later, if you wish.";
    }
  };
  return (
    <Modal
      title={
        isActivate ? "Confirm Activation" : "Confirm Deactivation"
      }
      modalCloseButtonClick={() => {
        setShowConfirmStatusChangeModal(false);
      }}
      className="modal modal-dialog-scrollable"
    >
      <div className="modal-body">
        <p>{getBodyText()}</p>
      </div>
      <div className="modal-footer">
        <div className="w-100 d-flex justify-content-between">
          <Button
            text={"Cancel"}
            style={ButtonStyle.Info}
            onClick={() => setShowConfirmStatusChangeModal(false)}
          />
          <Button
            text={isActivate ? "Activate" : "Deactivate"}
            style={ButtonStyle.Primary}
            onClick={() => handleRecordStatusChange()}
          />
        </div>
      </div>
    </Modal>
  );
}

export default SetStatusModal;
